/**
 * Formats a numeric value as Omani Rial (OMR) with 3 decimal places and comma thousands separator.
 * Output format: "OMR 1,234.567"
 * @param {number|string} value - The amount to format
 * @returns {string} Formatted currency string
 */
export const formatOMR = (value) => {
  const num = parseFloat(value) || 0;
  return `OMR ${num?.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}`;
};

/**
 * Formats a numeric value with 3 decimal places and comma thousands separator (no currency prefix).
 * @param {number|string} value - The amount to format
 * @returns {string} Formatted number string e.g. "1,234.567"
 */
export const formatNumber3 = (value) => {
  const num = parseFloat(value) || 0;
  return num?.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
};

export default formatOMR;
